<template>
    <section>
        <div class="container">
            <div class="row pb-5">
                <div class="col-12">
                    <div id="accordion">
                        <!-- q1 -->
                        <div class="card">
                            <div class="card-header" id="headingOne">
                                <h3 class="mb-0">
                                    <button class="btn btn-faq text-left pl-2" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        {{ $t("faqPage.questions[0]") }}
                                    </button>
                                </h3>
                            </div>

                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                <div class="card-body">
                                     <p class="pl-2">{{ $t("faqPage.answers[0]") }}</p>
                                </div>
                            </div>
                        </div>
                        <!-- q2 -->
                        <div class="card">
                            <div class="card-header" id="headingTwo">
                                <h5 class="mb-0">
                                    <button class="btn btn-faq collapsed text-left pl-2" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    {{ $t("faqPage.questions[1]") }}
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                <div class="card-body">
                                    <p class="pl-2">{{ $t("faqPage.answers[1]") }}</p>
                                </div>
                            </div>
                        </div>
                        <!-- q3 -->
                        <div class="card">
                            <div class="card-header" id="headingThree">
                                <h5 class="mb-0">
                                    <button class="btn btn-faq collapsed text-left pl-2" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    {{ $t("faqPage.questions[2]") }}
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                <div class="card-body">
                                    <p class="pl-2">{{ $t("faqPage.answers[2]") }}</p>
                                </div>
                            </div>
                        </div>
                        <!-- q4 -->
                        <div class="card">
                            <div class="card-header" id="headingFour">
                                <h5 class="mb-0">
                                    <button class="btn btn-faq collapsed text-left pl-2" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    {{ $t("faqPage.questions[3]") }}
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordion">
                                <div class="card-body" v-html='$t("faqPage.answers[3]")'>]</div>
                            </div>
                        </div>
                        <!-- q5 -->
                        <div class="card">
                            <div class="card-header" id="headingFive">
                                <h5 class="mb-0">
                                    <button class="btn btn-faq collapsed text-left pl-2" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    {{ $t("faqPage.questions[4]") }}
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordion">
                                <div class="card-body">
                                    <p class="pl-2">{{ $t("faqPage.answers[4]") }}</p>
                                </div>
                            </div>
                        </div>
                        <!-- q6 -->
                        <div class="card">
                            <div class="card-header" id="headingSix">
                                <h5 class="mb-0">
                                    <button class="btn btn-faq collapsed text-left pl-2" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    {{ $t("faqPage.questions[5]") }}
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordion">
                                <div class="card-body">
                                    <p class="pl-2">{{ $t("faqPage.answers[5]") }}</p>
                                </div>
                            </div>
                        </div>
                        <!-- q7 -->
                        <div class="card">
                            <div class="card-header" id="headingSeven">
                                <h5 class="mb-0">
                                    <button class="btn btn-faq collapsed text-left pl-2" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                    {{ $t("faqPage.questions[6]") }}
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordion">
                                <div class="card-body">
                                   <p class="pl-2"> {{ $t("faqPage.answers[6]") }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>

export default {
  name: "faqContent"
};
</script>